import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';

/**
 * Loader interceptor - DISABLED by default.
 * 
 * The loader will only show for requests with header 'X-Enable-Loader: true'.
 * Services should add this header when they want to show the loader.
 * 
 * Example in service:
 * { headers: new HttpHeaders().set('X-Enable-Loader', 'true') }
 */
@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptor implements HttpInterceptor {
  private readonly enableHeader = 'X-Enable-Loader';

  constructor(private readonly loaderService: LoaderService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let shouldEnable = false;
    try {
      shouldEnable = !!(request?.headers?.has?.(this.enableHeader));
    } catch {
      shouldEnable = false;
    }

    const cleanedRequest = shouldEnable && request?.headers
      ? request.clone({ headers: request.headers.delete(this.enableHeader) })
      : request;

    if (shouldEnable) {
      this.loaderService.increment();
    }

    return next.handle(cleanedRequest).pipe(
      finalize(() => {
        if (shouldEnable) {
          this.loaderService.decrement();
        }
      })
    );
  }
}

